import { useSelector } from 'react-redux'
import { ExpandablePanel, If } from '../../../..'
import AppreciationBody from './AppreciationBody'
import AppreciationLabel from './AppreciationLabel'
import { selectAppreciationRelevancy } from '../../../../../store/selectors/shouldYouSell'
import { EXPANDED_HOME_APPRECIATION_EVENT } from '../../../../../constants/client/clientEvents'
import { ClientEventName } from '../../../../../api/gqlaxy/gql/generated/graphql'
import baseStyles from '../ShouldYouSell.module.scss'

const Appreciation = () => {
  const appreciationRelevancy = useSelector(selectAppreciationRelevancy)

  return (
    <If condition={appreciationRelevancy}>
      <ExpandablePanel
        className={baseStyles.panel}
        eventName={ClientEventName.ExpandedHomeAppreciation}
        data-qa='appreciation'
      >
        <ExpandablePanel.Label>
          <AppreciationLabel />
        </ExpandablePanel.Label>
        <ExpandablePanel.Body>
          <AppreciationBody />
        </ExpandablePanel.Body>
      </ExpandablePanel>
    </If>
  )
}

export default Appreciation
